// Central data + UTM helpers for the Бабушка Варвара landing.
import { getOrCreateClickToken } from "./track.js";

const runtimeConfig = (typeof window !== "undefined" && window.APP_CONFIG) || {};

export const MAX_BOT_BASE = runtimeConfig.MAX_BOT_LINK || "https://max.ru/se13294157_1_bot";
export const MAX_CHANNEL_URL = runtimeConfig.MAX_CHANNEL_LINK || "https://max.ru/channel_varvarataro";
export const TELEGRAM_BOT_BASE = runtimeConfig.TELEGRAM_BOT_LINK || "https://t.me/varvarahiro_bot";
export const OFFER_URL = "https://tarovarvara.ru/oferta";
export const PRIVACY_URL = "https://tarovarvara.ru/privacy";

export const BOT_BASE_BY_PLATFORM = { max: MAX_BOT_BASE, telegram: TELEGRAM_BOT_BASE };
// В Telegram ведём только на бота: канал там пустой, подписки собираем в MAX.
export const CHANNEL_URL_BY_PLATFORM = { max: MAX_CHANNEL_URL };

// Build a bot deep-link: start=<clickToken> — по этому токену бэкенд находит визит
// (yclid/UTM/ClientID Метрики, сохранённые через /webhooks/landing-visit, см. track.js:getOrCreateClickToken)
// и привязывает его к пользователю в bot_started. Telegram-бот принимает тот же start=.
export function buildBotLink(platform = "max") {
  const params = new URLSearchParams();
  params.set("start", getOrCreateClickToken() || "landing");
  if (typeof window !== "undefined") {
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      if (key.startsWith("utm_") && !params.has(key)) params.set(key, value);
    });
  }
  // Через URL(), а не строковую склейку "base?params" — иначе если в базовой ссылке
  // когда-нибудь окажется свой "?..." (например старое runtime-значение из config.js),
  // получится невалидный двойной "?start=...?start=..." и бот не распознает метку источника.
  const url = new URL(BOT_BASE_BY_PLATFORM[platform] ?? MAX_BOT_BASE);
  params.forEach((value, key) => url.searchParams.set(key, value));
  return url.toString();
}

export function getUtm() {
  if (typeof window === "undefined") return { source: null, campaign: null };
  const current = new URLSearchParams(window.location.search);
  return {
    source: current.get("utm_source"),
    campaign: current.get("utm_campaign"),
  };
}

export const BENEFITS = [
  { label: "2 минуты", note: "первый разбор" },
  { label: "Всегда онлайн", note: "24 / 7" },
  { label: "Анонимно", note: "никто не узнает" },
  { label: "Без регистрации", note: "просто напишите" },
];

export const SERVICES = [
  {
    icon: "Sparkles",
    title: "Разбор по имени",
    text: "Что имя говорит о характере, судьбе и скрытых сильных сторонах.",
  },
  {
    icon: "CalendarHeart",
    title: "Разбор по дате рождения",
    text: "Числовой портрет: таланты, задачи и поворотные периоды жизни.",
  },
  {
    icon: "Layers",
    title: "Расклад Таро",
    text: "Ответ на конкретный вопрос — любовь, работа, выбор пути.",
  },
  {
    icon: "Hand",
    title: "Чтение по ладони",
    text: "Линии судьбы, сердца и ума по фотографии вашей руки.",
  },
  {
    icon: "HeartHandshake",
    title: "Совместимость",
    text: "Насколько вы подходите друг другу — по именам и датам двоих.",
  },
];

export const STEPS = [
  { n: "01", title: "Нажмите кнопку", text: "Чат с Бабушкой Варварой открывается прямо здесь, на сайте." },
  { n: "02", title: "Напишите боту", text: "Без регистрации и установки приложений — просто начните диалог." },
  { n: "03", title: "Задайте вопрос", text: "Выберите тип разбора и укажите нужные данные." },
  { n: "04", title: "Получите разбор", text: "Ответ придёт за пару минут." },
];

// price здесь — запасной вариант на случай, если /api/pricing недоступен;
// боевые цены Pricing.jsx подтягивает из БД (Product.priceRub, та же таблица,
// что правит владелец в админке), сверяя по code.
export const PRICES = [
  { code: "mini_tarot_199", title: "Мини-разбор Таро", price: "199 ₽", desc: "Один вопрос — один короткий ответ", badge: null },
  { code: "standard_tarot_399", title: "Стандартный Таро", price: "399 ₽", desc: "Развёрнутый расклад с толкованием", badge: "ХИТ" },
  { code: "name_standard_349", title: "Разбор по имени", price: "349 ₽", desc: "Полный числовой портрет имени", badge: null },
  { code: "birthdate_standard_349", title: "Разбор по дате", price: "349 ₽", desc: "Матрица судьбы по дате рождения", badge: null },
  { code: "palm_399", title: "Чтение по ладони", price: "399 ₽", desc: "Анализ по фотографии руки", badge: null },
  { code: "compatibility_399", title: "Совместимость", price: "399 ₽", desc: "Разбор пары по именам и датам", badge: null },
  { code: "deep_personality_199", title: "Глубокий разбор", price: "199 ₽", desc: "Дополнение к любому раскладу", badge: null },
  { code: "pack_5_mini_799", title: "Пакет 5 мини-разборов", price: "799 ₽", desc: "Пять вопросов выгодным пакетом", badge: "-30%" },
];

export const BOT_CHATS = [
  {
    messages: [
      { from: "user", text: "Здравствуйте! Сделаете расклад Таро — получится ли у нас с ним снова наладить отношения? 🙏", time: "21:14" },
      { from: "bot", text: "Скорее да — движение к сближению уже есть. Карты легли так: Влюблённые, Двойка Кубков, Звезда.", time: "21:14" },
      { from: "bot", text: "Влюблённые — про выбор, который давно назрел. Двойка Кубков — что чувство взаимное. Звезда — доверие возвращается, но после паузы, не сразу. Не дави: дай ему сделать шаг первым.", time: "21:15" },
      { from: "user", text: "Спасибо! Прямо в точку 💛", time: "21:16" },
    ],
  },
  {
    messages: [
      { from: "user", text: "Разбор по дате рождения: 14.07.1990", time: "10:02" },
      { from: "bot", text: "Число пути — 4. Ты человек-опора: на тебя часто перекладывают ответственность, и ты редко отказываешь.", time: "10:02" },
      { from: "bot", text: "Сильная сторона — надёжность, на тебя можно положиться. Слабое место — тянешь всё в одиночку, даже когда тяжело. Разумный шаг: в этом месяце прямо попросить о помощи хотя бы раз, не дожидаясь предела.", time: "10:03" },
      { from: "user", text: "Ого, прямо про меня. Спасибо! 🌙", time: "10:04" },
    ],
  },
  {
    messages: [
      { from: "user", text: "Сделаете разбор по имени? Меня зовут Виктория", time: "15:20" },
      { from: "bot", text: "Со стороны в тебе видят мягкость, но внутри — воля и умение доводить дело до конца, об этом мало кто догадывается.", time: "15:20" },
      { from: "bot", text: "Сильная сторона — ты не бросаешь начатое. Риск — из-за этой самой мягкости план держишь в себе и не просишь поддержки. Стоит один раз проговорить его вслух — раньше, чем додумаешь всё сама.", time: "15:21" },
      { from: "user", text: "Как в точку, спасибо большое", time: "15:22" },
    ],
  },
  {
    messages: [
      { from: "user", text: "Здравствуйте, хочу разбор по ладони 🤚", time: "18:03" },
      { from: "user", text: "📷 Фото ладони", time: "18:03" },
      { from: "bot", text: "Вижу на фото: ладонь квадратная, пальцы короче среднего — это про практичность, ты больше опираешься на факты, чем на эмоции.", time: "18:04" },
      { from: "bot", text: "Линия сердца длинная и чёткая — про глубокую привязанность, не про лёгкие увлечения. Линия судьбы прерывается ближе к середине: похоже на смену пути, а не на провал, дальше она снова ровная.", time: "18:04" },
      { from: "user", text: "Спасибо, очень интересно!", time: "18:05" },
    ],
  },
  {
    messages: [
      { from: "user", text: "Можно проверить совместимость? Анна и Дмитрий, встречаемся год", time: "19:47" },
      { from: "bot", text: "Скорее есть настоящая близость, а не просто привычка друг к другу. Анна даёт тепло и мягкость, Дмитрий — силу и стабильность.", time: "19:47" },
      { from: "bot", text: "Точка притяжения — умеете поддерживать друг друга без слов. Возможный конфликт — оба склонны молчать о недовольстве, пока не накопится. Стоит проговаривать раздражение сразу, пока оно маленькое.", time: "19:48" },
      { from: "user", text: "Прям в точку, спасибо 🙏", time: "19:49" },
    ],
  },
];

export const PRIVACY = [
  {
    icon: "ShieldCheck",
    title: "Полная анонимность",
    text: "Мы не спрашиваем документы и настоящее имя. Разбор остаётся между вами и ботом.",
  },
  {
    icon: "Lock",
    title: "Данные под защитой",
    text: "Переписка в мессенджере зашифрована. Мы не передаём информацию третьим лицам.",
  },
  {
    icon: "Trash2",
    title: "Ничего лишнего",
    text: "Не храним лишних данных и не рассылаем спам. Вы контролируете диалог сами.",
  },
];

export const FAQ = [
  {
    q: "Это точно предсказание будущего?",
    a: "Нет. Это развлекательный формат и повод для размышления о себе. Разбор помогает взглянуть на ситуацию под новым углом, но не является гарантией событий и не заменяет консультацию специалиста.",
  },
  {
    q: "Можно ли спрашивать про здоровье, суды или инвестиции?",
    a: "Мы не даём медицинских, юридических, финансовых или психологических консультаций. По таким вопросам обращайтесь к профильным специалистам. Разбор носит исключительно развлекательный характер.",
  },
  {
    q: "Где получить разбор?",
    a: "Прямо на этом сайте: нажмите «Начать разбор здесь» — откроется чат с Бабушкой Варварой, регистрация не нужна. Если удобнее в мессенджере, тот же бот работает в Telegram и MAX.",
  },
  {
    q: "Как происходит оплата?",
    a: "Разборы оплачиваются прямо в боте картой или через СБП (Мир, Visa, Mastercard). Оплата безопасная, данные карты боту не передаются.",
  },
];
